import { z } from "zod";

const CreateRoomMaintenanceResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        checkin_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
        checkout_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
        room_type_id: z.string().uuid(),
        room_id: z.string().uuid(),
        note: z.nullable(z.string()).optional(),
        property_id: z.string().uuid(),
        id: z.string().uuid(),
        updated_at: z.string().datetime(),
        created_at: z.string().datetime(),
    }),
});

export default CreateRoomMaintenanceResponse;
export type RoomMaintenanceResponse = z.infer<typeof CreateRoomMaintenanceResponse>;